interface PageBannerProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}

const PageBanner = ({ title, subtitle, backgroundImage }: PageBannerProps) => {
  return (
    <section className="relative pt-20 min-h-[40vh] flex items-center justify-center overflow-hidden">
      {backgroundImage && (
        <div className="absolute inset-0">
          <img loading="lazy" src={backgroundImage} alt="" className="w-full h-full object-cover"  />
          <div className="absolute inset-0 bg-charcoal/60" />
        </div>
      )}
      {!backgroundImage && (
        <div className="absolute inset-0 bg-primary" />
      )}
      <div className="relative z-10 container-max px-4 sm:px-6 lg:px-8 py-20 text-center">
        <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-primary-foreground mb-4">
          {title}
        </h1>
        {subtitle && (
          <p className="text-lg md:text-xl text-primary-foreground/80 max-w-3xl mx-auto leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageBanner;
